import { useAvatarSpeech } from "./AvatarSpeechContext";
import Spinner from "../spinner";

// Speaker icon on a bot bubble: click to hear the reply, click again to stop.
// Speaking also drives the avatar's mouth, since both read the same audio.
const SpeakButton = ({ id, message, primaryColor }) => {
  const { toggleSpeak, speakingId, loadingId, speechError } = useAvatarSpeech();
  const loading = loadingId === id;
  const playing = speakingId === id;
  const active = playing || loading;
  const error = speechError?.id === id ? speechError : null;

  return (
    <span className="inline-flex items-center gap-2 flex-wrap">
      <button
        type="button"
        onClick={() => toggleSpeak(id, message)}
        title={active ? "Stop" : error ? "Retry" : "Listen"}
        aria-label={active ? "Stop reading this reply" : error ? "Retry reading this reply" : "Read this reply aloud"}
        className="inline-flex items-center shrink-0 text-gray-400 hover:opacity-80 transition-colors"
        style={{ color: playing ? primaryColor : undefined }}
      >
        {loading ? (
          <Spinner size="h-4 w-4" color="text-gray-400" />
        ) : playing ? (
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <rect x="6" y="6" width="12" height="12" rx="1.5" />
          </svg>
        ) : (
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M3 10v4h4l5 5V5L7 10H3zm13.5 2c0-1.77-1.02-3.29-2.5-4.03v8.06c1.48-.74 2.5-2.26 2.5-4.03zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
          </svg>
        )}
        {error && <span className="ml-1 text-xs">Retry</span>}
      </button>
      {error && <span role="status" className="text-xs text-red-600">{error.message}</span>}
    </span>
  );
};

export default SpeakButton;
